import { UnitCard, UnitCardProps } from '@/components/UnitCard'

interface MapUnitPopupProps {
	unit: Omit<
		UnitCardProps,
		| 'layout'
		| 'highlighted'
		| 'onClick'
		| 'onPricingClick'
		| 'onHoverStart'
		| 'onHoverEnd'
		| 'className'
	>
	x: number
	y: number
	/** Use `position: fixed` (for portal rendering outside overflow containers). */
	fixed?: boolean
	className?: string
}

export function MapUnitPopup ({
	unit,
	x,
	y,
	fixed = false,
	className = ''
}: MapUnitPopupProps) {
	return (
		<div
			className={`spaces-map-popup ${fixed ? 'spaces:fixed' : 'spaces:absolute'} spaces:z-10 spaces:pointer-events-none ${className}`}
			style={{ left: x, top: y, transform: 'translate(-50%, calc(-100% - 12px))' }}
		>
			<UnitCard {...unit} layout='compact' />
		</div>
	)
}
